import * as THREE from "three";
import {
  SNAP_HANDLE_RADIUS,
  SNAP_HANDLE_OFFSET,
  SNAP_LINE_HANDLES_COLOR,
  windowLocalToWorld,
} from "./utils";

const SnapLines = ({
  snapLines,
  windowCoordSystem,
  onPointerDown,
  isDraggingSnapLine,
}) => {
  const { bounds } = snapLines;

  return (
    <group>
      {snapLines.horizontal.map((line, index) => {
        if (line.v === undefined || line.localCoords === undefined) return null;

        const start = windowLocalToWorld(
          bounds.minU,
          line.v,
          windowCoordSystem
        );
        const end = windowLocalToWorld(bounds.maxU, line.v, windowCoordSystem);

        const handlePos = new THREE.Vector3().addVectors(
          new THREE.Vector3(start.x, start.y, start.z).multiplyScalar(
            1 - SNAP_HANDLE_OFFSET
          ),
          new THREE.Vector3(end.x, end.y, end.z).multiplyScalar(
            SNAP_HANDLE_OFFSET
          )
        );

        return (
          <group key={`h-${index}`}>
            <line>
              <bufferGeometry>
                <bufferAttribute
                  attach="attributes-position"
                  array={
                    new Float32Array([
                      start.x,
                      start.y,
                      start.z,
                      end.x,
                      end.y,
                      end.z,
                    ])
                  }
                  count={2}
                  itemSize={3}
                />
              </bufferGeometry>
              <lineBasicMaterial
                color={SNAP_LINE_HANDLES_COLOR}
                opacity={0.6}
                transparent
                lineWidth={5}
              />
            </line>
            <mesh
              position={[handlePos.x, handlePos.y, handlePos.z]}
              onPointerDown={(e) => {
                onPointerDown("horizontal", line.v, e);
              }}
              onPointerEnter={(e) => {
                e.stopPropagation();
                document.body.style.cursor = isDraggingSnapLine
                  ? "grabbing"
                  : "grab";
              }}
              onPointerLeave={(e) => {
                e.stopPropagation();
                if (!isDraggingSnapLine) {
                  document.body.style.cursor = "default";
                }
              }}
            >
              <sphereGeometry args={[SNAP_HANDLE_RADIUS, 16, 16]} />
              <meshBasicMaterial
                color={SNAP_LINE_HANDLES_COLOR}
                transparent
                opacity={0.8}
              />
            </mesh>
          </group>
        );
      })}
      {snapLines.vertical.map((line, index) => {
        if (line.u === undefined || line.localCoords === undefined) return null;

        const start = windowLocalToWorld(
          line.u,
          bounds.minV,
          windowCoordSystem
        );
        const end = windowLocalToWorld(line.u, bounds.maxV, windowCoordSystem);

        const handlePos = new THREE.Vector3().addVectors(
          new THREE.Vector3(start.x, start.y, start.z).multiplyScalar(
            1 - SNAP_HANDLE_OFFSET
          ),
          new THREE.Vector3(end.x, end.y, end.z).multiplyScalar(
            SNAP_HANDLE_OFFSET
          )
        );

        return (
          <group key={`v-${index}`}>
            <line>
              <bufferGeometry>
                <bufferAttribute
                  attach="attributes-position"
                  array={
                    new Float32Array([
                      start.x,
                      start.y,
                      start.z,
                      end.x,
                      end.y,
                      end.z,
                    ])
                  }
                  count={2}
                  itemSize={3}
                />
              </bufferGeometry>
              <lineBasicMaterial
                color={SNAP_LINE_HANDLES_COLOR}
                opacity={0.6}
                transparent
              />
            </line>
            <mesh
              position={[handlePos.x, handlePos.y, handlePos.z]}
              onPointerDown={(e) => onPointerDown("vertical", line.u, e)}
              onPointerEnter={(e) => {
                e.stopPropagation();
                document.body.style.cursor = isDraggingSnapLine
                  ? "grabbing"
                  : "grab";
              }}
              onPointerLeave={(e) => {
                e.stopPropagation();
                if (!isDraggingSnapLine) {
                  document.body.style.cursor = "default";
                }
              }}
            >
              <sphereGeometry args={[SNAP_HANDLE_RADIUS, 16, 16]} />
              <meshBasicMaterial
                color={SNAP_LINE_HANDLES_COLOR}
                transparent
                opacity={0.8}
              />
            </mesh>
          </group>
        );
      })}
    </group>
  );
};

export default SnapLines;
